import { type CanvasElement, type SlotId, type WithSlots } from '@blaze-runtime/engine-domain';
import { STYLED_SLOT_SUPPORTED_ELEMENT_TYPES } from '@blaze-shared/theming-domain';

import { hasSlots } from '../../canvas-elements/element-model/element-props-guards';

export function hasStyleableSlots(
  element: CanvasElement | undefined,
): element is CanvasElement & WithSlots<SlotId> {
  return hasSlots(element) && STYLED_SLOT_SUPPORTED_ELEMENT_TYPES.includes(element.type);
}
